/*
Sohel 10/12/2022 2700430604 Trigger and Trigger Group ->Added code Validation and Autosuggestion
Sohel 11/03/2022 2700430604 Added Event Type Lookup
Sohel 11/08/2022 2700430604 get Trigger Id and Fixed Toast Message Issue
Sohel 11/08/2022 2700430604 get Trigger Id and Fixed Toast Message Issue
Sohel 11/14/2022 2699767208 implemented Copy Functionality
Sohel 12/03/2022 2700271704 Triggers Alter Custom window changes
Saikrishna 01/05/2023 2700271704 Added downloadSuccessMsg
Akhila 02/17/2023 2700271704 Added configurationUrl for preview file
Akhila 02/28/2023 2700271704 Added loader and download toast message in preview FIle
Sohel 01/31/2023 2701334326 Action Dropdown Changes
Akhila 04/27/2023 2700271704 Added popOver funtionality in report code field and trigger code field
Akhila 06/21/2023 2700271704 conditionally disable save and finish button on submission
Sohel 10/07/2023 2700271704 Field Name GET API Url Changes
Dilip-pds 10/31/2023 2700271704 added field based on Add/Remove Billing Indicator
*/

import {createSlice} from '@reduxjs/toolkit';
import {
  CLOSURE_CODE,
  DISPOSITION_CODE,
  EVENT_ACTION,
  EVENT_TYPE_TRIGGER,
  EVENT_ACTON,
} from '../../../constants/Lookup';
import {httpGet, httpPost} from '../../../util/Rest';
import {fetchDownloadSuccess} from '../PreviewFileData';
import {submissionEnd} from '../CommonActions/commonActions';

const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  addEventTacticStatus: null,
  eventTacticsActionsList: [],
  eventTacticActionParams: [],
  searchRuleGroupFieldData: {},
  dispositionDropDown: [],
  actionFormData: {},
  eventTacticData: {},
  userDefinedFieldsData: [],
  eventDropDownData: [],
  userDefinedWindowData: [],
  userDefinedWindowStatus: null,
  userDefinedFieldsStatus: null,
  eventTacticsPrintStatus: null,
  allTriggerCode: [],
  triggerId: null,
  copyReportStatus: null,
  iscopyLoading: false,
  copySuccessMsg: null,
  copyErrorMsg: null,
  downloadSuccessMsg: null,
  triggerUsageData: [],
  configurationUrl: '',
  dockey: '',
  allbatchTriggerData: [],
  allBillingIndicator: [],
};

const slice = createSlice({
  name: 'addEventTactic',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCopy: (state) => {
      state.iscopyLoading = true;
      state.errorMsg = null;
    },
    fetchCopyError: (state, action) => {
      state.copyErrorMsg = action.payload;
      state.iscopyLoading = false;
    },
    postEventTacticData: (state, action) => {
      state.addEventTacticStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
      state.triggerId = action.payload?.response?.id;
    },
    getEventTacticActions: (state, action) => {
      state.eventTacticsActionsList = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addEventTacticStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getUserDefinedActions: (state, action) => {
      state.userDefinedWindowData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.userDefinedWindowStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    postCopyReportData: (state, action) => {
      state.copyReportStatus = action.payload?.status;
      state.iscopyLoading = false;
      state.copySuccessMsg = action.payload?.message;
      state.copyErrorMsg = null;
      state.copyCode = action.payload?.response?.id;
    },
    getEventTacticActionParams: (state, action) => {
      state.eventTacticActionParams = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addEventTacticStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getDispositionDropDown: (state, action) => {
      state.dispositionDropDown = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addEventTacticStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getEventTacticData: (state, action) => {
      state.eventTacticData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addEventTacticStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getAllTriggerCode: (state, action) => {
      state.allTriggerCode = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getAllBillingIndicator: (state, action) => {
      state.allBillingIndicator = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getUserDefinedFieldsData: (state, action) => {
      state.userDefinedFieldsData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.userDefinedFieldsStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getTriggerUsageData: (state, action) => {
      state.isLoading = false;
      state.successMsg = false;
      state.errorMsg = false;
      state.triggerUsageData = action.payload;
    },
    setSearchRuleGroupFieldData: (state, action) => {
      state.searchRuleGroupFieldData = action.payload;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ?
        action.payload.data.error :
        action?.payload?.data?.message;
      state.isLoading = false;
    },
    fetchErrorMsg: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetStatus: (state, action) => {
      state.addEventTacticStatus = null;
      state.isLoading = false;
      state.eventTacticsActionsList = [];
      state.eventTacticActionParams = [];
      state.eventTacticData = {};
      state.triggerId = null;
    },
    resetMessage: (state, action) => {
      state.addEventTacticStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.eventTacticsPrintStatus = null;
      state.downloadSuccessMsg = null;
    },
    resetEventTacticParams: (state, action) => {
      state.eventTacticActionParams = [];
      state.actionFormData = {};
    },
    setActionFormData: (state, action) => {
      state.actionFormData = action.payload;
    },
    getEventTacticStatus: (state, action) => {
      state.addEventTacticStatus = action.payload.status;
    },
    setEventTacticsPrintData: (state, action) => {
      state.eventTacticsPrintStatus = action.payload.status;
      state.downloadSuccessMsg = action.payload.response;
      state.isLoading = false;
    },
    resetData: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.addEventTacticStatus = null;
      state.eventTacticsActionsList = [];
      state.eventTacticActionParams = [];
    },
    resetCopyReportData: (state, action) => {
      state.copyReportStatus = null;
      state.iscopyLoading = false;
      state.copySuccessMsg = null;
      state.copyErrorMsg = null;
    },
    resetTriggerUsageData: (state, action) => {
      state.triggerUsageData = {};
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
    getBatchTriggerCode: (state, action) => {
      state.allbatchTriggerData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchStart,
  postEventTacticData,
  getEventTacticActions,
  getUserDefinedActions,
  getEventTacticActionParams,
  fetchSuccess,
  fetchError,
  resetMessage,
  postCopyReportData,
  fetchCopyError,
  fetchCopy,
  resetStatus,
  resetData,
  resetEventTacticParams,
  getDispositionDropDown,
  setSearchRuleGroupFieldData,
  setActionFormData,
  getEventTacticData,
  getUserDefinedFieldsData,
  getEventTacticStatus,
  postEventDropDownData,
  setEventTacticsPrintData,
  getAllTriggerCode,
  fetchErrorMsg,
  resetCopyReportData,
  getTriggerUsageData,
  resetTriggerUsageData,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
  getBatchTriggerCode,
  getAllBillingIndicator,
} = slice.actions;

export const postEventTactic = (passValues) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`event/save/tactic`, passValues)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postEventTacticData(data));
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchErrorMsg(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchEventTacticActions = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [EVENT_ACTON],
    })
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getEventTacticActions(data?.data?.EVENT_ACTON));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchUserDefinedWindows = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet('data-repository/find/all/repositoryNames')
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getUserDefinedActions(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchUserDefinedFields = (dataRepositoryId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`data-repository/find/all/fieldNameAndType?repositoryName=${dataRepositoryId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getUserDefinedFieldsData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchEventTacticActionParams = (actionCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`event/find/tactic/action/${actionCode}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          const sortedParams = [...data.response.param];
          sortedParams.sort((a, b) => a['seqNo'] - b['seqNo']);
          dispatch(getEventTacticActionParams({...data.response, param: sortedParams}));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postCopyReport = (details) => {
  return (dispatch) => {
    dispatch(fetchCopy());
    httpPost(`event/save/copy/trigger`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCopyReportData(data));
        } else {
          dispatch(fetchCopyError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchCopyError(error.message));
      });
  };
};
export const fetchDispositionCodes = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [DISPOSITION_CODE, CLOSURE_CODE, EVENT_ACTION, EVENT_TYPE_TRIGGER],
    })
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getDispositionDropDown(data.data));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchEventTactic = (eventTacticId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`event/find/tactic/${eventTacticId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getEventTacticData(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchTriggerUsage = (triggerId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`event/usage/${triggerId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getTriggerUsageData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const fetchEventTacticsExecute = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`eventtactis/execute`, details)
      .then((data) => {
        if ((data?.status === 200 && data?.data?.status === 400) || data.status === 500) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data));
          dispatch(getEventTacticStatus(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAllTriggerCode = () => {
  return (dispatch) => {
    httpGet(`event/find/all/triggercodeanddescription`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllTriggerCode(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchBillingIndicator = () => {
  return (dispatch) => {
    httpGet(`billing/find/all/mstbi`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllBillingIndicator(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const handleSearchRuleGroupFieldData = (status) => {
  return (dispatch) => {
    dispatch(setSearchRuleGroupFieldData(status));
  };
};
export const printEventTactics = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`event/print/eventtacticsdata`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postPrintEventTactics({dockey: data?.message}, data));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postPrintEventTactics = (payload, postRuleGroupData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`event/generateurl/print/eventtactics`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(setEventTacticsPrintData(postRuleGroupData));
          // download(data.data);
          dispatch(fetchDownloadSuccess(postRuleGroupData));
          dispatch(setConfigUrl(data?.data || ''));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const fetchExistingBatchTriggerCode = (repositoryCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`event/find/all/eventtriggergroup`)
      .then((data) => {
        if (data && data?.status && data?.status === 200) {
          dispatch(getBatchTriggerCode(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};

export const ResetEventTacticParams = () => {
  return (dispatch) => {
    dispatch(resetEventTacticParams());
  };
};

export const SetActionFormData = (values) => {
  return (dispatch) => {
    dispatch(setActionFormData(values));
  };
};
export const resetCopyReport = () => {
  return (dispatch) => {
    dispatch(resetCopyReportData());
  };
};

export const resetTriggerUsage = () => {
  return (dispatch) => {
    dispatch(resetTriggerUsageData());
  };
};
